import React, { useState, useEffect, useContext, useRef } from "react";
import UserRow from "../user/UserRow";
import "./Stage.scss";
import TaskCard from "../task/TaskCard";
import UserInfoCard from "../../components/user/UserInfoCard";
import PopUpWindow from "../../components/popUpWindow/PopUpWindow";
import TaskDetails from "../../components/task/TaskDetails";
import dashboardApi from "../../services/dashboardApi";
import { AuthContext } from "../../context/AuthContext";
import { convertTimeToISO, convertTo24Hour, findEndTime } from "../../utils/common";
import Loader from "../loader/Loader";
import { ROStatusEnum } from "../../enum/enums";

const Stage = ({triggerStatusBarReload,closePopin} ) => {
  const { manageTimeSlots, timeSlots, slotUnitWidth } = useContext(AuthContext);
  const firstElementRef = useRef(null);
  const [unitWidth, setUnitWidth] = useState();
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  useEffect(() => {
    if (firstElementRef.current) {
      const width = firstElementRef.current.getBoundingClientRect().width;
      setUnitWidth(width);
    }
  }, [data, timeSlots]);

 

  

  const handleDrop = async (task) => {
    const stage = data.find((stage) => stage._id === task.stage._id);
    const startTime = convertTimeToISO(task.startTime);
    const endTime = findEndTime(startTime, task.duration);
    let formattedData = {
      repairOrderId: task.repairOrderId,
      roNumber: task.roNumber,
      roStageId: task.stage._id,
      roStageName: stage.roStageName,
      technicianId: task.user.id,
      technicianName: "T",
      taskStartDate: startTime,
      taskEndDate: endTime,
      taskStartSlotId: task.timeId,
      duration: task.duration,
      customerName: task.customerName,
      partsReceivedPercentage: task.partsReceivedPercentage,
      taskStatus: ROStatusEnum.NOT_STARTED,
    };
    const response = await dashboardApi.createorupdaterotaskschedule(
      formattedData
    );
    await fetchData();
  };
  const checkAllowDrop = (slot) => {
    const currentTime = new Date().getHours();
    const slotTime = convertTo24Hour(slot.time);
    if (slotTime < currentTime) {
      return false;
    }
  
    if (Object.keys(slot.task).length === 0) {
      if (slot.break || slot.allocated) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  
  const [ShowPopup, setShowPopup] = useState(false);
  const openPopup = async (task,user) => {    
    const response = await dashboardApi.getRepairORder(task.repairOrderId)    
    if(response.data.ok){
      const orderStatus=response.data.repairOrder[0].roStatus;
      if(orderStatus != ROStatusEnum.COMPLETED){
        setSelectedTask(task);  // Store task data
        setSelectedUser(user);  //store user
        setShowPopup(true);
      }
    }     // Show popup
  };
  const closePopup = () => {
    setShowPopup(false);    // Close popup
    setSelectedTask(null);  // Clear selected task data
    setSelectedUser(null); 
  };
  const [error, setError] = useState(null);
  const [viewLoader, setViewLoader] = useState(false);
  const fetchData = async () => {
    setData([]);
    setViewLoader(true)
    try {
      const response = await dashboardApi.getAllStagesWithUsers();
      setViewLoader(false)
      manageTimeSlots(response?.data?.stageWithUsers[0]?.users[0]?.slots);
      setData(response?.data?.stageWithUsers);
      triggerStatusBarReload();
    } catch (error) {  
      setViewLoader(false)    
    } finally {
      setViewLoader(false)
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  
 
  const findNextSlotWithTask = (currentIndex, user) => {
    
    let indx;


    if(user.slots[currentIndex].task[0]?.duration > 1){
      indx = currentIndex + user.slots[currentIndex].task[0]?.duration
    }else{
      indx = currentIndex + 1
    }

    
    
    for (
      let i = indx;
      i < user.slots.length;
      i++
    ) {
      if (user.slots[i]?.allocated || user.slots[i]?.break) {
        return i - indx; 
      }
    }
    return 0; 
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          //display: "flex",
          height: "100%",
          //flexDirection: "column",
          position: "relative",
        }}
      >
        {viewLoader  ? 
        <Loader />
        :
        <>
          <div className="timeRow">
            <div className="time"></div>
            <div className="timeline">
              {timeSlots?.map((slot, index) => (
                <div key={"time-"+slot.id} className={slot.break ? "timeColumn break" : "timeColumn"}>
                  {slot.time}
                </div>
              ))}
            </div>
          </div>
          
            {data?.map((stage, stageIndex) => (
              <div
              key={stage._id}
                className="w-100 stage-wrap"
              >
                <div className="stages" key={stageIndex}>
                  <div className="stage-head">
                    <div className="stage-title">
                      <h3>{stage.roStageName}</h3>
                    </div>
                    <div className="stage-icon">
                      <img src={apiBaseUrl + stage.stageImagePath} alt='Stage Image'/>
                    </div>
                  </div>
                  <div>
                    {stage.users?.map((user, userIndex) => (
                      <div
                      key={user._id}
                        className={
                          user.leaveStatus === "off"
                            ? "userRow onLeave"
                            : "userRow"
                        }
                      >
                        <div className="userDetails">
                          <UserInfoCard user={user} />
                        </div>
                        <div className="timeline">

                          {user.slots?.map((slot, index) => {
                            

                            const slotsUntilNextTask =
                              findNextSlotWithTask(index, user);

                          return (
                            <div
                              key={index}
                              ref={index === 0 ? firstElementRef : null}
                              className={
                                !checkAllowDrop(slot)
                                  ? "timeColumn break"
                                  : "timeColumn"
                              }
                            >
                              <UserRow
                                key={userIndex}
                                stage={stage}
                                time={slot}
                                user={user}
                                handleDrop={handleDrop}
                                allowDrop={checkAllowDrop(slot)}
                              >
                                {Object.keys(slot.task).length !== 0 &&
                                  unitWidth && (
                                    <TaskCard
                                      refetchData={fetchData}
                                      unitWidth={unitWidth}
                                      task={slot.task[0]}
                                      onClick={() => openPopup(slot.task[0],user)}
                                      showStage={false}
                                      stage={stage}
                                      user={user}
                                      slotsUntilNextTask={slotsUntilNextTask > 0 ? slotsUntilNextTask : 0}
                                      slot={slot}
                                    />
                                  )}
                              </UserRow>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        
        </>}
      </div>
      {ShowPopup && (
        <PopUpWindow closePopup={closePopup}>
          <TaskDetails task={selectedTask} userdetails={selectedUser} refetchData={fetchData} closePopup={closePopup} triggerStatusBarReload={triggerStatusBarReload} closePopin={closePopin} />
        </PopUpWindow>
      )}
    </div>
  );
};

export default Stage;
